import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types' //eslint-disable-line
import { Button } from 'advenio-components'
import RadioGroup from '../CustomButtons/RadioGroup'

const MealContainer = styled.div`
  width: 50%;
  margin-bottom: 40px;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
const SaveContainer = styled.div`
 width: 100%;
 height: 60px;
 position: fixed;
 bottom: 0;
 background-color: transparent;
 justify-content:flex-end;
 align-items: center;
 display: flex;
`

class Meal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: null,
    }
  }

  componentWillMount = () => {
    if (this.props.info.type_id) {
      this.setState({ selected: this.props.info.type_id })
    }
  }
  componentDidMount = () => {
    const { setMealAsDefault } = this.props
    if (setMealAsDefault) {
      setMealAsDefault()
    }
  }

  setInfo = (id, name) => {
    const nextState = { ...this.props.info }
    nextState[name] = id
    const params = {
      category_id: this.props.category,
      type_id: name
    }
    this.setState(nextState, () => {
      this.props.setExtraData(params)
      if (this.props.group) {
        this.goTo()
      }
    })
  }

  goTo = () => {
    this.props.goToView('drink', '','')
  }

  getType = () => {
    let categoryIndex = this.props.category - 1
       const types = this.props.categories[categoryIndex].types.map((currentValue, index, array) => { //eslint-disable-line
        return (
          <div key={currentValue.id} label={currentValue.translations.es} name={currentValue.id} selected={this.state.selected} />
        )
      })
    return (
      types
    )
  }

  render() {
    return (
      <MealContainer>
        <RadioGroup setInfo={this.setInfo} goToView={this.props.goToView}>
          {this.getType()}
        </RadioGroup>
      </MealContainer>
    )
  }
}

Meal.propTypes = {
  goToView: PropTypes.func.isRequired,
  setExtraData: PropTypes.func.isRequired,
}


export default Meal



// WEBPACK FOOTER //
// ./src/Components/Activity/Meal.jsx